<div class="report-date-filter d-flex flex-wrap align-items-end gap-3">
	@if (mode() === 'asOf') {
		<div class="report-date-filter-field">
			<label for="reportAsOfDate" class="form-label mb-1">As of date</label>
			<input
				type="date"
				id="reportAsOfDate"
				class="form-control form-control-sm"
				[value]="asOfDate()"
				[disabled]="disabled()"
				(change)="onAsOfDateChanged($any($event.target).value)" />
		</div>
	} @else {
		<div class="report-date-filter-field">
			<label for="reportStartDate" class="form-label mb-1">Start date</label>
			<input
				type="date"
				id="reportStartDate"
				class="form-control form-control-sm"
				[value]="startDate()"
				[disabled]="disabled()"
				(change)="onStartDateChanged($any($event.target).value)" />
		</div>
		<div class="report-date-filter-field">
			<label for="reportEndDate" class="form-label mb-1">End date</label>
			<input
				type="date"
				id="reportEndDate"
				class="form-control form-control-sm"
				[value]="endDate()"
				[disabled]="disabled()"
				(change)="onEndDateChanged($any($event.target).value)" />
		</div>
	}
</div>
